(function () {
  if (window.__larLanding) return; window.__larLanding = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var eur = function (n) { return Math.round(n).toLocaleString('es-ES') + ' €'; };

  function mainForm() {
    return document.querySelector('product-form form[action*="/cart/add"], .product-form form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]:not([data-lar-form])');
  }
  function goBuy(e) {
    if (e) e.preventDefault();
    var f = mainForm();
    var t = f ? (f.closest('.product__info-wrapper, .product__info-container, section') || f) : document.querySelector('main');
    if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.lar-reveal');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initPains(root) {
    var btns = root.querySelectorAll('.lar-pain'); if (!btns.length) return;
    var out = root.querySelector('[data-lar-count]'), box = root.querySelector('.lar-result');
    function upd() {
      var n = root.querySelectorAll('.lar-pain[aria-pressed="true"]').length;
      if (!out) return;
      out.innerHTML = n === 0 ? 'Toca las que te pasen 👆'
        : n === 1 ? 'Has marcado <b>1</b>. La guía te dice cómo resolverla.'
        : 'Has marcado <b>' + n + '</b>. La guía te dice cómo resolver las ' + n + '.';
      if (box && !reduce) { box.classList.add('is-bump'); setTimeout(function () { box.classList.remove('is-bump'); }, 220); }
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); upd(); }); });
    upd();
  }

  function initCalc(root) {
    var c = root.querySelector('[data-lar-calc]'); if (!c) return;
    var gasto = c.querySelector('[name="gasto"]'), temp = c.querySelector('[name="temp"]');
    var segs = c.querySelectorAll('.lar-seg button');
    var MESES = 5, PCT = 0.07, OBJ = 21, KW = 35, PRECIO = parseFloat(c.getAttribute('data-price')) || 9.99;
    var shown = 0, raf;
    function paint(el) { var p = (el.value - el.min) / (el.max - el.min) * 100; el.style.setProperty('--p', p + '%'); }
    function animate(to) {
      var big = c.querySelector('[data-o="total"]');
      if (reduce) { big.textContent = eur(to); shown = to; return; }
      cancelAnimationFrame(raf); var from = shown, t0 = performance.now();
      (function step(t) { var k = Math.min(1, (t - t0) / 450); k = 1 - Math.pow(1 - k, 3); shown = from + (to - from) * k; big.textContent = eur(shown); if (k < 1) raf = requestAnimationFrame(step); })(t0);
    }
    function calc() {
      var g = +gasto.value, T = +temp.value, kw = 0;
      segs.forEach(function (s) { if (s.getAttribute('aria-pressed') === 'true') kw = +s.dataset.kw; });
      var grados = Math.max(0, T - OBJ);
      var calor = g * MESES * Math.min(grados * PCT, 0.35);
      var pot = kw * KW, total = calor + pot;
      c.querySelector('[data-o="gasto"]').textContent = g + ' €/mes';
      c.querySelector('[data-o="temp"]').textContent = T + ' °C';
      c.querySelector('[data-o="calor"]').textContent = eur(calor);
      c.querySelector('[data-o="pot"]').textContent = eur(pot);
      var pay = c.querySelector('[data-o="pay"]');
      if (total >= 1) {
        var semanas = Math.max(1, Math.ceil(PRECIO / (total / 52)));
        pay.innerHTML = 'Con este ahorro estimado, la guía (' + PRECIO.toFixed(2).replace('.', ',') + ' €) <b>se pagaría sola en ' + (semanas <= 1 ? 'menos de una semana' : 'unas ' + semanas + ' semanas') + '</b>.';
      } else {
        pay.innerHTML = '¡Bien! Tu termostato ya está en su punto. Aun así, la guía revisa tu <b>tarifa, tu potencia y las ayudas</b>, que es donde más gente paga de más.';
      }
      animate(total); paint(gasto); paint(temp);
    }
    gasto.addEventListener('input', calc); temp.addEventListener('input', calc);
    segs.forEach(function (s) { s.addEventListener('click', function () { segs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); s.setAttribute('aria-pressed', 'true'); calc(); }); });
    calc();
  }

  function initRail(root) {
    var rail = root.querySelector('.lar-rail'); if (!rail) return;
    var cards = rail.children, dots = root.querySelectorAll('.lar-dots span');
    var prev = root.querySelector('[data-dir="-1"]'), next = root.querySelector('[data-dir="1"]');
    function idx() { var x = rail.scrollLeft, best = 0, d = 1e9; for (var i = 0; i < cards.length; i++) { var dd = Math.abs(cards[i].offsetLeft - rail.offsetLeft - x - parseFloat(getComputedStyle(rail).paddingLeft)); if (dd < d) { d = dd; best = i; } } return best; }
    function upd() { var i = idx(); dots.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); if (prev) prev.disabled = rail.scrollLeft < 8; if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8; }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { rail.scrollBy({ left: +b.dataset.dir * (cards[0].offsetWidth + 14), behavior: reduce ? 'auto' : 'smooth' }); }); });
    upd();
  }

  function initDays(root) {
    var tabs = root.querySelectorAll('.lar-day'); if (!tabs.length) return;
    var bar = root.querySelector('.lar-progress i'), lbl = root.querySelector('[data-lar-day-l]');
    var seen = {};
    function show(i) {
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; if (k < i) t.classList.add('is-done'); });
      root.querySelectorAll('.lar-panel').forEach(function (p, k) { p.hidden = k !== i; });
      seen[i] = 1; if (bar) bar.style.width = ((i + 1) / tabs.length * 100) + '%';
      if (lbl) lbl.textContent = 'Día ' + (i + 1) + ' de ' + tabs.length;
      var nb = root.querySelector('[data-lar-next]'); if (nb) nb.textContent = i === tabs.length - 1 ? 'Quiero empezar mi semana →' : 'Siguiente día →';
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) { var n = e.key === 'ArrowRight' ? k + 1 : e.key === 'ArrowLeft' ? k - 1 : -1; if (n >= 0 && n < tabs.length) { e.preventDefault(); show(n); tabs[n].focus(); } });
    });
    var nx = root.querySelector('[data-lar-next]');
    if (nx) nx.addEventListener('click', function () { var cur = 0; tabs.forEach(function (t, k) { if (t.getAttribute('aria-selected') === 'true') cur = k; }); if (cur < tabs.length - 1) show(cur + 1); else goBuy(); });
    show(0);
  }

  function initSticky(root) {
    var bar = root.querySelector('.lar-sticky'); if (!bar) return;
    document.body.appendChild(bar);
    var anchor = document.querySelector('product-form, .product-form') || mainForm();
    var finalSec = root.querySelector('.lar-final');
    var aboveFold = true, finalVisible = false;
    function upd() { bar.classList.toggle('is-on', !aboveFold && !finalVisible); }
    if ('IntersectionObserver' in window) {
      if (anchor) new IntersectionObserver(function (e) { aboveFold = e[0].isIntersecting || e[0].boundingClientRect.top > 0; upd(); }).observe(anchor);
      else { aboveFold = false; }
      if (finalSec) new IntersectionObserver(function (e) { finalVisible = e[0].isIntersecting; upd(); }, { threshold: 0.2 }).observe(finalSec);
    } else { bar.classList.add('is-on'); }
    upd();
  }

  function init(root) {
    root = root || document;
    initReveal(root); initPains(root); initCalc(root); initRail(root); initDays(root); initSticky(root);
    root.querySelectorAll('[data-lar-buy]').forEach(function (a) { a.addEventListener('click', goBuy); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
